import { Component } from '@angular/core';

import { AdminSidebarComponent } from '../admin-sidebar/admin-sidebar.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-base-admin-layout',
  imports: [AdminSidebarComponent, RouterModule],
  templateUrl: './base-admin-layout.component.html',
})
export class BaseAdminLayoutComponent {}
